<template>
    <div id="secondary">
        <div class="header">
            <img v-if="lang=='zh-CN'" :src="cdnPrefix+'/imgs/sec-top.png'" />
            <img v-if="lang=='ja'" :src="cdnPrefix+'/imgs/sec-top.png'" />
            <img v-if="lang=='en'" :src="cdnPrefix+'/imgs/sec-top-en.png'" />
            <img v-if="lang=='th'" :src="cdnPrefix+'/imgs/sec-top-th.png'" />
        </div>

        <div class="content">
            <router-view :isMobile="isMobile" :cdnPrefix="cdnPrefix" />
        </div>

        <Footer :isMobile="isMobile" :cdnPrefix="cdnPrefix"></Footer>
    </div>
</template>

<script>
import Footer from "./Footer.vue";
export default {
    name: "Secondary",
    components: {
        Footer
    },
    props: {
        isMobile: {
            type: Boolean,
            default: false
        },
        cdnPrefix: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            lang: window.localStorage.getItem("localeLanguage")
        };
    },
    watch: {
        $route(to, from) {
            document.documentElement.scrollTo(0, 0);
        }
    },
    mounted() {},
    methods: {}
};
</script>

<style lang="scss">
#secondary {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    min-height: 100%;
    padding-bottom: 250px;
    background: url($cdnPrefix+"/imgs/sec-bg.png") repeat;
    .header {
        img {
            width: 100%;
        }
    }
    .content {
        width: 60%;
        margin: 0 auto;
        background: url($cdnPrefix+"/imgs/sec-cont-bg.png") repeat;
    }
    .footer {
        position: absolute;
        bottom: 0;
    }
}
@media screen and (max-width: 768px) {
    #secondary {
        .content {
            width: 95%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Secondary.vue